export const translations = {
	fr: {
		nav: {
			allPasswords: "Tous les mots de passe",
			secureNotes: "Notes sécurisées",
			folders: "Dossiers",
			generator: "Générateur",
			security: "Sécurité",
			breachDetector: "Détecteur de fuites",
			contact: "Contact",
			home: "Accueil",
			settings: "Paramètres",
			stats: "Statistiques",
			passwords: "Mots de passe",
			securityScore: "Score de sécurité",
			loading: "Chargement...",
			secure: "Sécurisé",
			encryptedWith: "Vos données sont chiffrées avec AES-256",
			signOut: "Se déconnecter",
		},
		footer: {
			navigation: "Navigation",
			support: "Support",
			legal: "Légal",
			security: "Sécurité",
			generator: "Générateur",
			settings: "Paramètres",
			legalNotice: "Mentions légales",
			privacy: "Confidentialité",
			terms: "CGU",
			cookies: "Cookies",
			encryption: "Chiffrement AES-256",
			gdpr: "RGPD Compliant",
			copyright: "© {year} SkromaPASS. Tous droits réservés.",
			description:
				"Votre gestionnaire de mots de passe sécurisé. Protégez vos accès en ligne avec un chiffrement AES-256.",
			register: "S'inscrire",
			login: "Connexion",
			contact: "Contact",
			madeWith: "Fait avec ❤️ en France",
		},
		headerHome: {
			generator: "Générateur",
			contact: "Contact",
			login: "Connexion",
			register: "S'inscrire",
			dashboard: "Dashboard",
			openMenu: "Ouvrir le menu",
			closeMenu: "Fermer le menu",
		},
		home: {
			badge: "Sécurité maximale garantie",
			heroTitle1: "Vos mots de passe,",
			heroTitle2: "en toute sécurité",
			heroSubtitle:
				"Gestionnaire de mots de passe moderne avec chiffrement AES-256. Protégez vos accès en ligne avec SkromaPASS.",
			ctaStart: "Commencer gratuitement",
			ctaLogin: "Se connecter",
			ctaDashboard: "Accéder au Dashboard",
			noCreditCard: "✓ Aucune carte bancaire requise",
			featuresTitle: "Pourquoi choisir SkromaPASS ?",
			featuresSubtitle:
				"Une solution complète pour gérer vos mots de passe",
			feature1Title: "Chiffrement AES-256",
			feature1Desc:
				"Vos données sont protégées par un chiffrement sécurisé. Personne ne peut accéder à vos mots de passe, même nous.",
			feature2Title: "Générateur sécurisé",
			feature2Desc:
				"Créez des mots de passe ultra-sécurisés en un clic. Personnalisez la longueur et les types de caractères pour une sécurité maximale.",
			feature3Title: "Organisation intuitive",
			feature3Desc:
				"Organisez vos mots de passe par dossiers et catégories. Retrouvez rapidement ce que vous cherchez.",
			statsTitle: "Rejoignez SkromaPASS aujourd'hui !",
			statSecure: "Sécurisé",
			statFree: "Gratuit",
			statAvailable: "Disponible",
			ctaTitle: "Prêt à sécuriser vos mots de passe ?",
			ctaDesc: "Créez votre compte gratuit en moins d'une minute.",
			ctaButton: "Commencer maintenant",
			footerAboutDesc:
				"Votre gestionnaire de mots de passe sécurisé et intuitif. Protégez vos données avec un chiffrement AES-256.",
			footerNavTitle: "Navigation",
			footerLegalTitle: "Légal",
			legalNotice: "Mentions légales",
			privacyPolicy: "Politique de confidentialité",
			terms: "CGU",
			cookiePolicy: "Politique de cookies",
			copyright: "Tous droits réservés.",
			footerInfo:
				"Chiffrement AES-256 | RGPD Compliant | Hébergé en Europe",
			trust1: "AES-256",
			trust2: "RGPD Compliant",
			trust3: "Hébergé en Europe",
			trust4: "100% Gratuit",
			featuresLabel: "Fonctionnalités",
			feature4Title: "Multi-facteurs",
			feature4Desc:
				"2FA TOTP, code PIN et biométrie pour une protection maximale de votre compte.",
			feature5Title: "Breach Lab",
			feature5Desc:
				"Détectez si vos mots de passe ont été compromis. Vos données ne quittent jamais votre appareil.",
			howTitle: "Prêt en 3 étapes",
			howStep1Num: "01",
			howStep1Title: "Créez votre compte",
			howStep1Desc:
				"Inscription gratuite en 30 secondes. Aucune carte bancaire requise.",
			howStep2Num: "02",
			howStep2Title: "Ajoutez vos accès",
			howStep2Desc:
				"Importez depuis Chrome, Bitwarden, 1Password ou ajoutez manuellement.",
			howStep3Num: "03",
			howStep3Title: "Installez l'extension (bientôt)",
			howStep3Desc:
				"Remplissez et enregistrez automatiquement vos mots de passe directement dans Chrome et Firefox.",
			extensionBadge: "Extension navigateur — Bientôt",
			extensionTitle: "Votre coffre dans votre navigateur",
			extensionSubtitle:
				"Auto-remplissage, sauvegarde en un clic et générateur intégré directement dans Chrome et Firefox.",
			extensionChrome: "Google Chrome",
			extensionFirefox: "Mozilla Firefox",
			extensionFeature1: "Auto-remplissage instantané",
			extensionFeature2: "Sauvegarde en un clic",
			extensionFeature3: "Générateur de mots de passe intégré",
			extensionFeature4: "Accès direct à votre coffre",
		},
		auth: {
			loginTitle: "Connexion",
			loginSubtitle: "Connectez-vous à votre compte",
			email: "Email",
			password: "Mot de passe",
			forgotPassword: "Mot de passe oublié ?",
			loginButton: "Se connecter",
			loginLoading: "Connexion...",
			noAccount: "Pas encore de compte ?",
			registerLink: "S'inscrire",
			errorCredentials: "Email ou mot de passe incorrect",
			errorNotVerified:
				"Votre email n'a pas encore été vérifié. Veuillez vérifier votre boîte de réception.",
			errorGeneral: "Une erreur est survenue",
			errorNetwork: "Une erreur est survenue. Vérifiez votre connexion.",
			registerTitle: "Inscription",
			registerSubtitle: "Créez votre compte sécurisé",
			nameLabel: "Nom",
			namePlaceholder: "Votre nom",
			passwordHint:
				"8 caractères minimum, avec majuscule, minuscule et chiffre",
			confirmPassword: "Confirmer le mot de passe",
			registerButton: "S'inscrire",
			registerLoading: "Création du compte...",
			successTitle: "Compte créé avec succès !",
			successEmailPrefix: "Un email de vérification a été envoyé à ",
			successEmailSuffix:
				". Veuillez vérifier votre boîte de réception et cliquer sur le lien pour activer votre compte.",
			successButton: "Compris",
			spamNote: "N'oubliez pas de vérifier votre dossier spam !",
			alreadyAccount: "Vous avez déjà un compte ?",
			loginLink: "Se connecter",
			passwordMismatch: "Les mots de passe ne correspondent pas",
			forgotTitle: "Mot de passe oublié",
			forgotSubtitle:
				"Saisissez votre email pour recevoir un lien de réinitialisation sécurisé.",
			emailLabel: "Adresse email",
			sendButton: "Envoyer le lien de réinitialisation",
			sendingButton: "Envoi en cours...",
			emailSentTitle: "Email envoyé !",
			emailSentPrefix: "Si un compte existe avec l'adresse ",
			emailSentMiddle:
				", vous recevrez un lien de réinitialisation valable ",
			emailSentDuration: "1 heure",
			spamCheck:
				"Vérifiez également vos spams si vous ne voyez pas l'email.",
			backToLogin: "Retour à la connexion",
			resetTitle: "Nouveau mot de passe",
			resetSubtitle: "Choisissez un mot de passe pour",
			newPasswordLabel: "Nouveau mot de passe",
			confirmPasswordLabel: "Confirmer le mot de passe",
			resetButton: "Réinitialiser le mot de passe",
			resettingButton: "Réinitialisation...",
			invalidLinkTitle: "Lien invalide",
			invalidLinkDesc:
				"Ce lien de réinitialisation est invalide ou a expiré.",
			requestNewLink: "Demander un nouveau lien",
			resetSuccessTitle: "Mot de passe modifié !",
			resetSuccessDesc:
				"Votre mot de passe a été réinitialisé avec succès.",
			resetSuccessNote:
				"Toutes vos sessions actives ont été déconnectées. Veuillez vous reconnecter avec votre nouveau mot de passe.",
			signInButton: "Se connecter",
			loadingPage: "Chargement...",
			strengthMin8: "8 caractères minimum",
			strengthLower: "Minuscule",
			strengthUpper: "Majuscule",
			strengthNumber: "Chiffre",
			strengthSpecial: "Caractère spécial",
		},
		verifyEmail: {
			loadingTitle: "Vérification en cours...",
			successTitle: "Email vérifié !",
			errorTitle: "Erreur de vérification",
			pendingTitle: "Vérifiez votre email",
			loadingMsg: "Vérification en cours...",
			successMsg: "Votre email a été vérifié avec succès !",
			errorInvalidToken:
				"Le lien de vérification est invalide ou a expiré. Veuillez demander un nouvel email de vérification.",
			errorMissingParams: "Lien de vérification incomplet.",
			errorServer:
				"Une erreur est survenue. Veuillez réessayer plus tard.",
			errorUnknown: "Une erreur inconnue est survenue.",
			errorGeneral: "Une erreur est survenue lors de la vérification",
			pendingMsg:
				"Vérifiez votre boîte email pour confirmer votre adresse.",
			signIn: "Se connecter",
			resendVerification: "Renvoyer l'email de vérification",
			backRegister: "Retour à l'inscription",
			backLogin: "Retour à la connexion",
			spamTip:
				"💡 Astuce : Vérifiez également votre dossier spam ou courrier indésirable.",
		},
		resendVerification: {
			title: "Renvoyer l'email de vérification",
			subtitle:
				"Entrez votre adresse email pour recevoir un nouveau lien de vérification",
			emailLabel: "Email",
			emailPlaceholder: "votre@email.com",
			sendButton: "Renvoyer l'email",
			sendingButton: "Envoi en cours...",
			errorGeneral: "Une erreur est survenue lors de l'envoi",
			alreadyVerified: "Email déjà vérifié ?",
			signIn: "Se connecter",
			noAccount: "Pas encore de compte ?",
			register: "S'inscrire",
			spamTip:
				"💡 Astuce : Vérifiez également votre dossier spam ou courrier indésirable.",
		},
		onboarding: {
			welcomeTitle: "Bienvenue sur SkromaPASS !",
			welcomeDesc:
				"Votre compte est créé. Prenons 2 minutes pour renforcer sa sécurité.",
			startButton: "Commencer la configuration",
			skipAll: "Passer et configurer plus tard dans les paramètres",
			doneTitle: "Configuration terminée !",
			doneDescNone:
				"Vous pourrez configurer ces options à tout moment dans vos paramètres.",
			doneDescActivatedPrefix: "Vous avez activé",
			doneDescOptionSg: "option de sécurité",
			doneDescOptionPl: "options de sécurité",
			doneDescSuffix: "Votre compte est bien protégé.",
			ignored: "Ignoré",
			goToDashboard: "Accéder à mon espace",
			stepLabel: "Étape",
			stepOf: "sur",
			twofaLabel: "Double authentification",
			twofaDesc:
				"Protégez votre compte avec une application comme Google Authenticator ou Authy. Un code à 6 chiffres sera demandé à chaque connexion.",
			pinLabel: "Code PIN",
			pinDesc:
				"Créez un code PIN de 4 à 8 chiffres pour accéder à vos mots de passe depuis votre dashboard. Ce code est une couche de sécurité supplémentaire qui protège vos données même si votre session est ouverte.",
			bioLabel: "Biométrie",
			bioDesc:
				"Enregistrez votre empreinte digitale ou Face ID pour accéder à vos mots de passe d'un simple toucher.",
			tfaActivate: "Activer le 2FA",
			tfaGenerating: "Génération du QR code…",
			tfaScanDesc:
				"Scannez ce QR code avec votre application (Google Authenticator, Authy…)",
			tfaManualCode: "Code manuel :",
			tfaInputPlaceholder: "Code à 6 chiffres",
			tfaVerifying: "Vérification…",
			tfaConfirm: "Confirmer",
			tfaEnabled: "2FA activé !",
			tfaProtected: "Votre compte est maintenant doublement protégé.",
			nextStep: "Étape suivante",
			pinPasswordLabel: "Mot de passe principal",
			pinPasswordPlaceholder: "Votre mot de passe",
			pinNewLabel: "Nouveau code PIN (4–8 chiffres)",
			pinConfirmLabel: "Confirmer le code PIN",
			pinInvalid: "Le PIN doit contenir entre 4 et 8 chiffres",
			pinMismatch: "Les codes PIN ne correspondent pas",
			pinCreating: "Configuration…",
			pinCreate: "Créer mon PIN",
			bioUnsupported:
				"La biométrie nécessite HTTPS et un appareil compatible. Vous pourrez l'activer plus tard depuis les paramètres.",
			bioContinue: "Continuer sans biométrie",
			bioDeviceLabel: "Nom de cet appareil",
			bioDevicePlaceholder: "Mon téléphone",
			bioRegistering: "Enregistrement…",
			bioRegister: "Enregistrer ma biométrie",
			skipStep: "Passer cette étape →",
			previousBtn: "Précédent",
		},
		tutorial: {
			nextBtn: "Suivant",
			finishBtn: "Terminer",
			skipBtn: "Passer le tutoriel",
			step1Title: "Bienvenue sur SkromaPASS !",
			step1Desc:
				"Découvrez votre tableau de bord. Ici vous pouvez voir vos statistiques de sécurité : le nombre total de mots de passe, les mots de passe forts et votre score de sécurité global.",
			step2Title: "Ajouter un mot de passe",
			step2Desc:
				"Cliquez ici pour ajouter un nouveau mot de passe. Vous pourrez entrer le nom du site, vos identifiants et même générer un mot de passe sécurisé automatiquement.",
			step3Title: "Rechercher rapidement",
			step3Desc:
				"Utilisez la barre de recherche pour retrouver instantanément vos mots de passe par nom, site web ou URL.",
			step4Title: "Trier et filtrer",
			step4Desc:
				"Utilisez les options de tri pour ordonner vos mots de passe : du plus Récent, par ordre Alphabétique (A-Z) ou par Force. Vous pouvez aussi filtrer directement par dossier depuis le menu latéral.",
			step5Title: "Menu de navigation",
			step5Desc:
				"Accédez à toutes les fonctionnalités via ce menu latéral : générateur de mots de passe, dossiers, contact, paramètres...",
			step6Title: "Organisez avec des dossiers",
			step6Desc:
				"Les dossiers vous permettent d'organiser vos mots de passe comme vous le souhaitez. C'est parfait pour une meilleure organisation !",
			step7Title: "Créer un dossier",
			step7Desc:
				"Cliquez ici pour créer un nouveau dossier. Vous pourrez lui donner un nom, une description et même choisir une couleur pour le personnaliser.",
			step8Title: "Accéder à vos dossiers",
			step8Desc:
				"Vos dossiers apparaissent ici. Cliquez sur un dossier pour voir tous les mots de passe qu'il contient. Vous pouvez ajouter des mots de passe directement depuis le dossier.",
			step9Title: "Sécurité renforcée : Double authentification",
			step9Desc:
				"La double authentification (2FA) ajoute une couche de sécurité supplémentaire. Même si quelqu'un connaît votre mot de passe, il ne pourra pas accéder à votre compte sans le code 2FA. Je vous recommande vivement de l'activer !",
			step10Title: "Accès rapide avec le code PIN",
			step10Desc:
				"Configurez un code PIN (4 à 8 chiffres) pour accéder rapidement à vos mots de passe sans avoir à saisir un mot de passe à rallonge à chaque fois. C'est pratique et sécurisé !",
			step11Title: "Accès biométrique",
			step11Desc:
				"Enregistrez votre empreinte digitale ou Face ID pour accéder à vos mots de passe d'un simple toucher, en remplacement ou en complément du code PIN. Ultra rapide et sécurisé !",
			step12Title: "Tutoriel terminé !",
			step12Desc:
				"Vous connaissez maintenant toutes les fonctionnalités principales de SkromaPASS ! N'hésitez pas à explorer l'application et à sécuriser tous vos mots de passe. 🔒",
		},
		dashboard: {
			loading: "Chargement...",
			title: "Mes mots de passe",
			subtitle:
				"Gérez tous vos mots de passe en un seul endroit sécurisé",
			import: "Importer",
			importTitle: "Importer depuis Bitwarden, LastPass, Chrome...",
			export: "Exporter",
			exportTitle: "Exporter le coffre chiffré (.mkp)",
			addPassword: "Ajouter un mot de passe",
			searchPlaceholder: "Rechercher par nom, email ou URL...",
			stats: {
				total: "Total des mots de passe",
				strong: "Mots de passe forts",
				score: "Score de sécurité",
			},
			filters: {
				all: "Tous",
				sort: {
					recent: "Récent",
					alpha: "A–Z",
					strength: "Force",
				},
			},
			pagination: {
				of: "sur",
			},
			empty: {
				title: "Aucun mot de passe",
				allFolders: "Commencez par ajouter votre premier mot de passe",
				folder: "Aucun mot de passe trouvé dans ce dossier",
			},
		},
		contact: {
			title: "Contactez-nous",
			subtitle:
				"Une question ? Un problème ? Nous sommes là pour vous aider",
			supportTitle: "Support par email",
			supportResponse: "Réponse sous 24-48h en semaine",
			tutorialTitle: "Tutoriel interactif",
			tutorialDesc: "Redécouvrez les fonctionnalités",
			tutorialRestart: "Relancer le tutoriel",
			nameLabel: "Nom complet",
			nameOptional: "(optionnel)",
			namePlaceholder: "Nom complet",
			emailLabel: "Adresse email",
			emailPlaceholder: "exemple@email.com",
			subjectLabel: "Sujet",
			subjectPlaceholder: "De quoi souhaitez-vous parler ?",
			messageLabel: "Message",
			messagePlaceholder: "Décrivez votre demande en détail...",
			sendButton: "Envoyer le message",
			sendingButton: "Envoi en cours...",
			successTitle: "Message envoyé avec succès !",
			successDesc: "Nous vous répondrons dans les plus brefs délais.",
			errorNetwork:
				"Impossible de contacter le serveur. Veuillez réessayer.",
			privacyNote:
				"🔒 Confidentialité : Vos informations sont sécurisées et ne seront jamais partagées avec des tiers.",
		},
		generator: {
			title: "Générateur de mots de passe",
			subtitle:
				"Créez des mots de passe sécurisés et aléatoires en quelques secondes",
			generatedLabel: "Mot de passe généré",
			placeholder: "Cliquez sur 'Générer' pour créer un mot de passe",
			ariaHide: "Masquer le mot de passe",
			ariaShow: "Afficher le mot de passe",
			ariaCopy: "Copier le mot de passe",
			copied: "✓ Copié dans le presse-papiers !",
			strengthWeak: "Faible",
			strengthMedium: "Moyen",
			strengthStrong: "Fort",
			optionsTitle: "Options de génération",
			lengthLabel: "Longueur :",
			lengthUnit: "caractères",
			lowercase: "Lettres minuscules (a-z)",
			uppercase: "Lettres majuscules (A-Z)",
			numbers: "Chiffres (0-9)",
			symbols: "Symboles (!@#$%^&*)",
			generateButton: "Générer un nouveau mot de passe",
			tipsTitle: "💡 Conseils de sécurité",
			tip1: "Utilisez au moins 12 caractères pour une meilleure sécurité",
			tip2: "Incluez des majuscules, minuscules, chiffres et symboles",
			tip3: "Ne réutilisez jamais le même mot de passe sur plusieurs sites",
			tip4: "Changez régulièrement vos mots de passe importants",
			warningTitle: "Attention",
			warningMessage:
				"Veuillez sélectionner au moins un type de caractère pour générer un mot de passe.",
		},
		security: {
			title: "Tableau de bord sécurité",
			subtitle:
				"Pilotez votre sécurité et accédez aux outils avancés de détection de fuite.",
			loading: "Chargement...",
			scoreTitle: "Score de sécurité",
			scoreDesc: "Basé sur la force et l'exposition de vos mots de passe",
			scoreExcellent: "Excellente",
			scoreGood: "Bonne",
			scoreAvg: "Moyenne",
			scoreWeak: "Faible",
			breachLabTitle: "Breach Lab dédié",
			breachLabDesc:
				"Nouvelle page complète pour scanner votre coffre, vérifier un mot personnalisé non enregistré et obtenir des conseils instantanés.",
			breachLabNote:
				"Vos mots de passe ne sont jamais envoyés en clair grâce à la méthode k-anonymity.",
			openBreachLab: "Ouvrir Breach Lab",
			breachDetected: "Fuites détectées",
			weakLabel: "Mots faibles",
			totalSecured: "Total sécurisés",
			strongPasswords: "Mots de passe forts",
			mediumPasswords: "Mots de passe moyens",
			weakPasswords: "Mots de passe faibles",
			addedThisMonth: "Ajoutés ce mois",
			priorityTitle: "Recommandations prioritaires",
			compromisedAlert: "compte(s) détecté(s) dans des fuites publiques",
			compromisedAction:
				"Lancez Breach Lab pour obtenir la liste et corriger rapidement.",
			weakAlert: "mot(s) de passe faible(s)",
			weakAction: "Renforcez-les avec le générateur intégré.",
			generateStrong: "Générez des mots robustes",
			openGenerator: "Ouvrir le générateur",
			securityInfoTitle: "Informations de sécurité",
			encryptionLabel: "Chiffrement",
			encryptionDesc: "Protection robuste des données sensibles.",
			pinLabel: "PIN de ré-authentification",
			pinTime: "15 minutes",
			pinDesc:
				"Vérification supplémentaire pour consulter vos mots de passe.",
			tfaLabel: "Double authentification",
			tfaOptional: "Optionnelle",
			tfaDesc:
				"Activez la 2FA pour une couche de sécurité supplémentaire.",
			outerCardTitle: "Votre sécurité, notre priorité",
			outerCardDesc:
				"Nous sommes dédiés à protéger vos données et à vous fournir les meilleurs outils pour gérer votre sécurité. Explorez les fonctionnalités de Breach Lab, renforcez vos mots de passe et restez informés pour garder une longueur d'avance sur les menaces.",
		},
		vault: {
			title: "Notes sécurisées",
			subtitle:
				"Codes PIN, identités et notes chiffrées en toute sécurité",
			newNote: "Nouvelle note",
			loading: "Chargement...",
			emptyTitle: "Aucune note sécurisée",
			emptyTitleAlt: "Aucune note",
			emptyDesc:
				"Stockez vos codes PIN, informations d'identité et notes sensibles de façon chiffrée.",
			createFirst: "Créer ma première note",
			deleteTitle: "Supprimer la note ?",
			deleteConfirm: "Supprimer",
			deleteNotePrefix: "Supprimer ",
			deleteNoteSuffix: "\u00a0? Cette action est irr\u00e9versible.",
			modifiedPrefix: "Modifié",
			hide: "Masquer",
			viewContent: "Voir le contenu",
			copyContent: "Copier le contenu",
			editAction: "Modifier",
			deleteAction: "Supprimer",
		},
		folders: {
			title: "Mes dossiers",
			loading: "Chargement...",
			folder: "dossier",
			folders: "dossiers",
			newButton: "Nouveau dossier",
			newButtonShort: "Nouveau",
			createTitle: "Créer un nouveau dossier",
			nameLabel: "Nom du dossier",
			namePlaceholder: "Ex\u00a0: Travail, Personnel, Famille...",
			descLabel: "Description",
			optional: "(optionnel)",
			descPlaceholder: "Décrivez le contenu de ce dossier...",
			colorLabel: "Couleur du dossier",
			creating: "Création...",
			createButton: "Créer le dossier",
			cancel: "Annuler",
			noDescription: "Aucune description",
			password: "mot de passe",
			passwords: "mots de passe",
			emptyTitle: "Aucun dossier pour le moment",
			emptyDesc:
				"Organisez vos mots de passe en créant des dossiers thématiques.",
			emptyDescLine2: "Parfait pour séparer vie pro et perso\u00a0!",
			createFirst: "Créer mon premier dossier",
			editTooltip: "Modifier le dossier",
			deleteTooltip: "Supprimer le dossier",
			saving: "Enregistrement...",
			saveChanges: "Enregistrer les modifications",
			errorCreate: "Erreur lors de la création du dossier",
			errorDelete: "Erreur lors de la suppression",
			errorUpdate: "Erreur lors de la modification du dossier",
			deleteTitle: "Supprimer le dossier",
			deleteMessage:
				"Êtes-vous sûr de vouloir supprimer ce dossier\u00a0? Tous les mots de passe qu'il contient seront également supprimés. Cette action est irréversible.",
			deleteConfirm: "Supprimer",
			errorAlertTitle: "Erreur",
		},
		folderDetail: {
			loading: "Chargement du dossier...",
			notFound: "Dossier introuvable",
			notFoundDesc: "Ce dossier n'existe pas ou a été supprimé.",
			backToFolders: "Retour aux dossiers",
			breadcrumbFolders: "Dossiers",
			noDescription: "Aucune description",
			password: "mot de passe",
			passwords: "mots de passe",
			addPassword: "Ajouter un mot de passe",
			addPasswordShort: "Ajouter",
			searchPlaceholder: "Rechercher par nom, email ou URL...",
			noResults: "Aucun résultat trouvé",
			emptyFolder: "Ce dossier est vide",
			noResultsDesc:
				"Aucun mot de passe ne correspond à votre recherche. Essayez avec d'autres mots-clés.",
			emptyFolderDesc:
				"Commencez par ajouter votre premier mot de passe dans ce dossier pour mieux organiser vos identifiants.",
			addFirst: "Ajouter mon premier mot de passe",
			results: "résultat(s) trouvé(s)",
			passwordsCount: "mot(s) de passe",
			clearSearch: "Effacer la recherche",
		},
		settings: {
			title: "Paramètres",
			subtitle: "Gérez vos préférences et paramètres de sécurité",
			tabAccount: "Compte",
			tabSecurity: "Sécurité",
			accountTitle: "Informations du compte",
			nameLabel: "Nom",
			namePlaceholder: "Votre nom",
			emailLabel: "Email",
			saving: "Enregistrement...",
			saveChanges: "Enregistrer les modifications",
			passwordTitle: "Modifier le mot de passe principal",
			currentPassword: "Mot de passe actuel",
			currentPasswordPlaceholder: "Votre mot de passe actuel",
			newPassword: "Nouveau mot de passe",
			newPasswordPlaceholder: "Au moins 8 caractères",
			confirmPassword: "Confirmer le mot de passe",
			confirmPasswordPlaceholder: "Confirmer le nouveau mot de passe",
			changingPassword: "Changement...",
			changePassword: "Changer le mot de passe",
			generalTitle: "Informations générales",
			accountCreated: "Compte créé le",
			emailVerifiedLabel: "Email vérifié",
			verified: "Vérifié",
			notVerified: "Non vérifié",
			savedPasswords: "Mots de passe enregistrés",
			loading: "Chargement...",
			deleteTitle: "Supprimer le compte",
			deleteDesc:
				"Cette action est irréversible. Votre compte et tous vos mots de passe seront définitivement supprimés. Assurez-vous d'avoir sauvegardé toutes les informations importantes avant de procéder.",
			deletePlaceholder: "Entrez votre mot de passe pour confirmer",
			deleteButton: "Supprimer définitivement mon compte",
			deleteModalTitle: "Supprimer votre compte",
			deleteModalMessage:
				"Êtes-vous sûr de vouloir supprimer votre compte\u00a0? Tous vos mots de passe seront définitivement supprimés. Cette action est irréversible.",
			deleteModalConfirm: "Supprimer mon compte",
			errMustEnterPassword: "Veuillez entrer votre mot de passe",
			errPasswordMismatch: "Les mots de passe ne correspondent pas",
			errPasswordTooShort:
				"Le mot de passe doit contenir au moins 8 caractères",
			successProfile: "Profil mis à jour avec succès",
			successPassword: "Mot de passe changé avec succès",
			successDelete: "Compte supprimé. Redirection...",
			errProfileUpdate: "Erreur lors de la mise à jour",
			errPasswordChange: "Erreur lors du changement",
			errDeleteAccount: "Erreur lors de la suppression",
		},
		pin: {
			title: "Code PIN",
			desc: "Configurez un code PIN rapide (4 à 8 chiffres) pour accéder à vos mots de passe",
			configured: "Code PIN configuré",
			notConfigured: "Aucun code PIN",
			configuredDesc: "Vous pouvez le modifier ou le supprimer",
			notConfiguredDesc: "Créez un code PIN pour un accès rapide",
			editBtn: "Modifier",
			createBtn: "Créer un code PIN",
			deleteBtn: "Supprimer",
			savingBtn: "Configuration...",
			saveEditBtn: "Modifier le code PIN",
			saveCreateBtn: "Créer le code PIN",
			cancelBtn: "Annuler",
			formTitle: "Création d'un code PIN",
			rule1: "Entre 4 et 8 chiffres uniquement",
			rule2: 'N\'utilisez pas un code évident de type "1234" ou "0000" de préférence',
			rule3: "Assurez-vous de choisir un code PIN que vous pouvez mémoriser facilement",
			rule4: "Le code PIN pourra être modifié ou supprimé à tout moment avec votre mot de passe principal",
			passwordLabel: "Mot de passe principal",
			passwordPlaceholder: "Entrez votre mot de passe",
			passwordHint: "Pour confirmer votre identité",
			newPinLabel: "Nouveau code PIN",
			pinPlaceholder: "4 à 8 chiffres",
			confirmPinLabel: "Confirmer le code PIN",
			confirmPinPlaceholder: "Répétez le code PIN",
			deleteModalTitle: "Supprimer le code PIN",
			deleteModalDesc:
				"Cette action supprimera définitivement votre code PIN. Vous devrez en créer un nouveau si vous voulez accéder à vos mots de passe à l'avenir.",
			deleteModalPasswordLabel: "Mot de passe principal",
			deleteModalPasswordPlaceholder:
				"Entrez votre mot de passe pour confirmer",
			deleteConfirmBtn: "Supprimer le PIN",
			errLength: "Le code PIN doit contenir entre 4 et 8 chiffres",
			errDigitsOnly: "Le code PIN ne doit contenir que des chiffres",
			errMismatch: "Les codes PIN ne correspondent pas",
			errSetup: "Erreur lors de la configuration",
			errDelete: "Erreur lors de la suppression",
			successModified: "Code PIN modifié avec succès",
			successCreated: "Code PIN créé avec succès",
			successDeleted: "Code PIN supprimé avec succès",
		},
		twoFactor: {
			title: "Authentification à deux facteurs",
			status: "Statut :",
			enabled: "Activée",
			disabled: "Désactivée",
			desc: "Ajoutez une couche de sécurité supplémentaire à votre compte en activant l'authentification à deux facteurs (2FA).",
			loadingBtn: "Chargement...",
			enableBtn: "Activer la 2FA",
			disableBtn: "Désactiver la 2FA",
			scanStep: "Étape 1 : Scannez le QR code",
			scanDesc:
				"Utilisez Google Authenticator, Microsoft Authenticator, ou toute autre application TOTP compatible.",
			manualScan: "Impossible de scanner ? Entrer la clé manuellement",
			secretLabel: "Clé secrète :",
			verifyStep: "Étape 2 : Vérifiez le code",
			codeLabel: "Entrez le code à 6 chiffres",
			verifyingBtn: "Vérification...",
			activateBtn: "Activer",
			cancelBtn: "Annuler",
			disableCodeLabel: "Entrez votre code 2FA pour désactiver",
			securityNote: "Sécurité renforcée :",
			securityNoteText:
				"La 2FA ajoute une couche de protection supplémentaire en demandant un code unique à chaque connexion, même si quelqu'un connaît votre mot de passe.",
			errSetup: "Erreur lors de la configuration",
			errInvalidCode: "Code invalide",
		},
		biometric: {
			title: "Empreinte / Face ID",
			desc: "Utilisez votre biométrie à la place du code PIN pour déverrouiller vos mots de passe.",
			checking: "Vérification de la biométrie…",
			httpsRequired: "HTTPS requis",
			httpsDesc:
				"L'authentification biométrique n'est disponible que sur HTTPS.",
			httpsLocal: "Pour tester depuis un téléphone sur le réseau local :",
			notSupported:
				"Votre navigateur ne supporte pas l'authentification biométrique. Essayez Chrome ou Safari à jour.",
			registeredDevices: "Appareils enregistrés",
			addedOn: "Ajouté le",
			deleteDeviceTooltip: "Supprimer cet appareil",
			deleteDeviceConfirm:
				"Supprimer cet appareil ? Vous ne pourrez plus utiliser sa biométrie pour vous authentifier.",
			nameLabel: "Donnez un nom à cet appareil (optionnel)",
			namePlaceholder: "Ex : Mon iPhone, PC bureau\u2026",
			registeringBtn: "En cours\u2026",
			registerBtn: "Confirmer avec votre biométrie",
			cancelBtn: "Annuler",
			addDeviceBtn: "Enregistrer cet appareil",
			defaultDeviceName: "Mon appareil",
			errInitRegister: "Impossible d'initialiser l'enregistrement.",
			errCancelled:
				"Enregistrement annulé. Veuillez accepter la demande biométrique.",
			errFailed: "L'enregistrement a échoué.",
			errDeleteFailed: "Suppression échouée",
			successRegistered: "Empreinte enregistrée avec succès !",
			successDeleted: "Appareil supprimé.",
		},
		breachLab: {
			title: "Détecteur de fuites",
			subtitle:
				"Vérifiez en un clic si vos mots de passe ont été volés lors d'un piratage de site web. Vos mots de passe ne quittent jamais votre appareil.",
			vaultCardTitle: "Analyser tous mes mots de passe",
			vaultCardDesc:
				"Vérifie en quelques secondes si l'un de vos mots de passe enregistrés a été compromis lors d'un piratage.",
			vaultCardNote:
				"🔒 Vos mots de passe ne sont jamais transmis — seule une empreinte partielle est envoyée.",
			scanBtn: "Lancer l'analyse",
			scanningBtn: "Analyse en cours...",
			compromisedAlert:
				"⚠️ {n} mot(s) de passe trouvé(s) dans des piratages connus — changez-les dès maintenant.",
			safeAlert:
				"✅ Aucun de vos mots de passe n'a été trouvé dans des piratages connus.",
			statsChecked: "Mots de passe vérifiés",
			statsCompromised: "Compromis détectés",
			statsUpdated: "Comptes mis à jour",
			statsCompromisedList: "Mots de passe compromis :",
			breachCount: "{n} fuite(s)",
			manualCardTitle: "Tester un mot de passe",
			manualCardDesc:
				"Vous pouvez tester n'importe quel mot de passe ici — même un que vous n'avez pas encore enregistré.",
			manualCardNote:
				"🔒 Ce mot de passe n'est jamais enregistré ni transmis en clair.",
			manualPlaceholder: "Tapez un mot de passe à tester...",
			strengthLabel: "Niveau de sécurité",
			crackTimeText:
				"Un pirate aurait besoin de {time} pour deviner ce mot de passe.",
			checkBtn: "Vérifier si ce mot de passe a fuité",
			checkingBtn: "Vérification en cours...",
			compromisedManualAlert:
				"⚠️ Ce mot de passe a été trouvé dans des piratages connus — évitez de l'utiliser.",
			safeManualAlert:
				"✅ Ce mot de passe n'a pas été trouvé dans des piratages connus.",
			seenTimes: "Vu {n} fois dans des piratages de sites web",
			howTitle: "Comment ça fonctionne ?",
			howPrivacyTitle: "🔒 Votre confidentialité est protégée",
			howPrivacyDesc:
				"Votre mot de passe n'est jamais envoyé à Internet. Seule une version tronquée et illisible est utilisée pour la vérification.",
			howSpeedTitle: "⚡ Résultats instantanés",
			howSpeedDesc:
				"L'analyse s'appuie sur une base de données de milliards de mots de passe volés lors de piratages réels de sites web.",
			howActionTitle: "🎯 Que faire si un mot de passe a fuité ?",
			howActionDesc:
				"Changez-le immédiatement sur le site concerné et générez-en un nouveau, unique et robuste.",
			generateBtn: "Générer un mot de passe robuste",
			scanUnavailable: "Scan indisponible",
			enterPassword: "Entrez un mot de passe à vérifier.",
			checkUnavailable: "Vérification indisponible",
			strength1: "Très faible — à changer immédiatement",
			strength2: "Faible — facile à deviner",
			strength3: "Moyen — peut être amélioré",
			strength4: "Fort — bon mot de passe",
			strength5: "Très fort — excellent choix !",
			crack0: "quelques secondes",
			crack1: "quelques minutes",
			crack2: "plusieurs jours",
			crack3: "plusieurs années",
			crack4: "des siècles",
			riskCritical: "🔴 Risque critique",
			riskHigh: "🟠 Risque élevé",
			riskMedium: "🟡 Risque modéré",
			riskLow: "🟢 Risque faible",
			riskNone: "✅ Aucune fuite détectée",
		},
		passwordModal: {
			title: "Ajouter un mot de passe",
			editTitle: "Modifier le mot de passe",
			nameLabel: "Nom du site / service",
			editNameLabel: "Nom du site / application",
			namePlaceholder: "Google, Facebook, etc.",
			editNamePlaceholder: "Ex\u00a0: Facebook, Gmail...",
			optional: "(optionnel)",
			usernameLabel: "Nom d'utilisateur",
			usernamePlaceholder: "utilisateur@exemple.com",
			editUsernamePlaceholder: "utilisateur123",
			emailLabel: "Email",
			emailPlaceholder: "utilisateur@exemple.com",
			editEmailPlaceholder: "email@exemple.com",
			passwordLabel: "Mot de passe",
			passwordPlaceholder: "Mot de passe sécurisé",
			generate: "Générer",
			generateSecure: "Générer un mot de passe sécurisé",
			strengthLabel: "Force du mot de passe",
			strengthWeak: "Faible",
			strengthMedium: "Moyen",
			strengthStrong: "Fort",
			websiteLabel: "Site web",
			websitePlaceholder: "exemple.com",
			folderLabel: "Dossier",
			folderNew: "Nouveau",
			folderNone: "Aucun dossier",
			folderNamePlaceholder: "Nom du dossier",
			folderCreate: "Créer",
			notesLabel: "Notes",
			notesPlaceholder: "Notes supplémentaires...",
			cancel: "Annuler",
			submit: "Ajouter",
			submitting: "Ajout en cours...",
			editSubmit: "Modifier",
			editSubmitting: "Modification...",
			errorTitle: "Erreur",
			addError:
				"Erreur lors de l'ajout du mot de passe. Veuillez réessayer.",
			editError:
				"Erreur lors de la modification du mot de passe. Veuillez réessayer.",
		},
		passwordCard: {
			copied: "Copié !",
			modifiedPrefix: "Modifié ",
			shareTitle: "Partager ce mot de passe",
			viewTitle: "Afficher le mot de passe",
			hideTitle: "Masquer le mot de passe",
			editTitle: "Modifier ce mot de passe",
			copiedTitle: "Copier dans le presse-papiers",
			deleteTitle: "Supprimer le mot de passe",
			deleteMessagePrefix:
				"\u00cates-vous s\u00fbr de vouloir supprimer \u00ab\u00a0",
			deleteMessageSuffix:
				"\u00a0\u00bb ? Cette action est irr\u00e9versible.",
			deleteConfirmBtn: "Supprimer",
			errorTitle: "Erreur",
			errorMessage:
				"Erreur lors de la suppression du mot de passe. Veuillez r\u00e9essayer.",
			notesLabel: "Notes",
			timeAgoNow: "\u00c0 l\u2019instant",
			timeAgoPrefix: "Il y a",
			timeAgoSuffix: "",
			timeUnitYear: "an",
			timeUnitYearPlural: "ans",
			timeUnitMonth: "mois",
			timeUnitMonthPlural: "mois",
			timeUnitWeek: "semaine",
			timeUnitWeekPlural: "semaines",
			timeUnitDay: "jour",
			timeUnitDayPlural: "jours",
			timeUnitHour: "heure",
			timeUnitHourPlural: "heures",
			timeUnitMinute: "minute",
			timeUnitMinutePlural: "minutes",
		},
		exportModal: {
			title: "Exporter le coffre",
			subtitle: "Format chiffré .mkp",
			warningTitle: "Mot de passe d'export — à ne pas oublier\u00a0!",
			warningDesc:
				"Ce mot de passe chiffre l'intégralité de votre coffre. Sans lui, vous ne pourrez pas réimporter vos données. Notez-le dans un endroit sûr avant de télécharger le fichier.",
			passwordLabel: "Mot de passe d'export",
			passwordPlaceholder: "8 caractères minimum",
			confirmLabel: "Confirmer le mot de passe",
			confirmPlaceholder: "Répétez le mot de passe",
			cancel: "Annuler",
			submit: "Télécharger",
			submitting: "Export en cours...",
			successTitle: "Export réussi\u00a0!",
			successDesc:
				"Votre coffre a été téléchargé. Conservez le fichier .mkp et votre mot de passe d'export en lieu sûr\u00a0: sans ce mot de passe, les données sont irrécupérables.",
			close: "Fermer",
			errTooShort: "Le mot de passe doit faire au moins 8 caractères.",
			errMismatch: "Les mots de passe ne correspondent pas.",
			errExport: "Erreur lors de l'export",
			exporting: "Export en cours...",
			download: "Télécharger",
		},
		importModal: {
			title: "Importer des mots de passe",
			subtitle: "Depuis un autre gestionnaire ou un export SkromaPASS",
			tabCsv: "Fichier CSV",
			tabMkp: "Export SkromaPASS (.mkp)",
			csvGuideTitle: "Comment exporter depuis votre gestionnaire\u00a0:",
			dropCsv: "Cliquez ou glissez-déposez un fichier CSV",
			dropMkp: "Cliquez ou glissez-déposez un fichier .mkp",
			dropping: "Déposez le fichier ici",
			maxSizeCsv: "Taille maximale\u00a0: 5 Mo",
			mkpDesc:
				"Sélectionnez un fichier .mkp exporté depuis SkromaPASS, puis entrez le mot de passe d'export que vous aviez défini lors de l'export.",
			fileLoaded: "Fichier chargé",
			mkpFileLoaded: "Fichier .mkp chargé",
			detected: "{n} mot(s) de passe détecté(s)",
			warningDups:
				"Les mots de passe seront ajoutés à votre coffre existant. Les doublons ne sont pas supprimés automatiquement.",
			changeFile: "Changer de fichier",
			importBtn: "Importer {n} mot(s) de passe",
			importing: "Import en cours...",
			exportPasswordLabel: "Mot de passe d'export",
			exportPasswordPlaceholder:
				"Le mot de passe défini lors de l'export",
			decrypting: "Déchiffrement...",
			importMkpBtn: "Importer",
			successTitle: "Import réussi\u00a0!",
			successDesc: "{n} mot(s) de passe importé(s) avec succès",
			close: "Fermer",
			errCsvType: "Veuillez sélectionner un fichier CSV",
			errCsvSize: "Fichier trop volumineux (5 Mo maximum)",
			errMkpType: "Veuillez sélectionner un fichier .mkp",
			errMkpSize: "Fichier trop volumineux (10 Mo maximum)",
			errImport: "Erreur lors de l'import",
			otherTools: "Gestionnaire avec export CSV compatible\u00a0:",
			BitwardenGuide: " Outils → Exporter le coffre (CSV)",
			LastPassGuide: " Paramètres → Exporter",
			"1PasswordGuide": " Fichier → Exporter (CSV)",
			ChromeGuide: " chrome://settings/passwords → Exporter",
		},
		reauthModal: {
			title: "Authentification requise",
			subtitle: "Pour afficher vos mots de passe.",
			noPinTitle: "Code PIN non configuré.",
			noPinDesc:
				"Veuillez configurer un code PIN dans les paramètres pour continuer. Il s'agit d'une mesure de sécurité supplémentaire pour protéger vos données.",
			bioWaiting: "En attente de votre biométrie…",
			bioTitle: "Vérification biométrique",
			bioSubtitle: "Utilisez votre empreinte ou Face ID",
			bioRetry: "Réessayer",
			bioWaitingBtn: "En attente…",
			usePinInstead: "Utiliser le code PIN à la place",
			useBiometric: "Utiliser la biométrie",
			pinLabel: "Entrez votre code PIN",
			backspace: "← Effacer",
			securityInfo:
				"🔒 Sécurité\u00a0: Cette vérification est valable pendant 15 minutes. Vous n'aurez pas besoin de vous réauthentifier pendant ce temps.",
			errBioInit: "Impossible d'initialiser la vérification biométrique.",
			errBioCancelled: "Authentification biométrique annulée.",
			errBioDevice: "Votre appareil n'a pas pu vérifier votre identité.",
			errBioFailed: "Vérification biométrique échouée.",
			errPinIncorrect: "Code PIN incorrect",
		},
		secureNoteModal: {
			addTitle: "Nouvelle note sécurisée",
			editTitle: "Modifier la note",
			titleLabel: "Titre",
			titlePlaceholder: "Ex\u00a0: Carte Visa, Code wifi...",
			contentLabel: "Contenu",
			contentPlaceholder:
				"Écrivez votre note, code PIN, numéro de carte...",
			encryptedNote:
				"Le contenu est chiffré avec AES-256-GCM avant d'être stocké",
			cancel: "Annuler",
			save: "Enregistrer",
			saving: "Sauvegarde...",
			create: "Créer la note",
			errTitle: "Le titre est requis",
			errContent: "Le contenu est requis",
			errSave: "Erreur lors de la sauvegarde",
		},
		shareModal: {
			title: "Partager ce mot de passe",
			securityNote:
				"Chiffrement dans votre navigateur — le serveur ne voit jamais le mot de passe en clair. La clé de déchiffrement est embarquée dans le lien.",
			linkTitleLabel: "Titre du lien",
			showNameToggle: "Afficher un titre au destinataire",
			hiddenNameHint:
				"Le destinataire verra \u00ab\u00a0Mot de passe partagé\u00a0\u00bb comme titre.",
			defaultName: "Mot de passe partagé",
			expiryLabel: "Expiration du lien",
			expiry1h: "1 heure",
			expiry24h: "24 heures",
			expiry3d: "3 jours",
			expiry7d: "7 jours",
			maxViewsLabel: "Nombre d'utilisations maximum",
			viewsCount: "{n} fois",
			cancel: "Annuler",
			createBtn: "Créer le lien",
			creating: "Création...",
			successMsg:
				"Lien créé avec succès\u00a0! Valide {time}\u00a0•\u00a0{n}\u00a0utilisation(s)",
			shareLink: "Lien de partage",
			copy: "Copier",
			copied: "Copié\u00a0!",
			warningShare:
				"Partagez ce lien uniquement avec la personne concernée.",
			warningKey:
				"La partie #clé après le lien est indispensable au déchiffrement — copiez le lien en entier.",
			close: "Fermer",
			err: "Erreur lors de la création du lien",
			linkCreated: "Lien créé avec succès ! Valide",
			use: "utilisation",
			fieldsLabel: "Champs à partager",
			fieldPassword: "Mot de passe",
			fieldAlwaysRequired: "(toujours inclus)",
			fieldUsername: "Identifiant",
			fieldEmail: "Email",
			fieldWebsite: "Site web",
			fieldNotes: "Notes",
		},
		authRequired: {
			login: "Connexion",
			register: "S\u2019inscrire",
			title: "Connexion requise",
			desc: "Vous devez \u00eatre connect\u00e9 pour acc\u00e9der \u00e0 cette page. Connectez-vous ou cr\u00e9ez un compte pour continuer.",
			loginBtn: "Se connecter",
			registerBtn: "Cr\u00e9er un compte",
			backHome: "\u2190 Retour \u00e0 l\u2019accueil",
		},
		shareToken: {
			copy: "Copier",
			copied: "Copi\u00e9\u00a0!",
			hide: "Masquer",
			show: "Afficher",
			loading: "V\u00e9rification du lien...",
			sharedPassword: "Mot de passe partag\u00e9",
			warningTitle: "Avant de r\u00e9v\u00e9ler ce mot de passe\u00a0:",
			warningDevice:
				"Assurez-vous d\u2019\u00eatre sur un appareil s\u00e9curis\u00e9",
			warningCount: "Cette action comptera comme une utilisation du lien",
			warningLast: "C\u2019est la derni\u00e8re utilisation disponible",
			viewsRemainingOne: "utilisation restante",
			viewsRemainingPlural: "utilisations restantes",
			expireOn: "Expire le",
			decrypting: "D\u00e9chiffrement...",
			revealBtn: "R\u00e9v\u00e9ler le mot de passe",
			fieldUsername: "Identifiant\u00a0/ Email",
			fieldPassword: "Mot de passe",
			fieldWebsite: "Site web",
			fieldNotes: "Notes",
			viewLeft: "vue restante",
			viewsLeft: "vues restantes",
			expiredTitle: "Ce lien a expir\u00e9",
			exhaustedTitle: "Lien \u00e9puis\u00e9",
			expiredDesc: "Ce lien de partage n\u2019est plus valide.",
			exhaustedDesc:
				"Ce lien a d\u00e9j\u00e0 \u00e9t\u00e9 utilis\u00e9 le nombre maximum de fois.",
			errorTitle: "Lien introuvable",
			footerSharedVia: "Partag\u00e9 via",
			footerTagline: "Gestionnaire de mots de passe chiffr\u00e9",
			errMissingToken: "Token manquant",
			errUnknown: "Erreur inconnue",
			errServerUnreachable: "Impossible de contacter le serveur",
			errMissingKey:
				"Cl\u00e9 de d\u00e9chiffrement manquante ou invalide \u2014 copiez l\u2019int\u00e9gralit\u00e9 du lien (y compris la partie apr\u00e8s #)",
			errDecrypt:
				"Impossible de d\u00e9chiffrer \u2014 cl\u00e9 invalide ou lien corrompu",
		},
		notFound: {
			title: "Page introuvable",
			subtitle:
				"Oups\u00a0! La page que vous recherchez semble ne pas exister. Elle a peut-\u00eatre \u00e9t\u00e9 d\u00e9plac\u00e9e ou n\u2019existe plus.",
			suggestions: "Suggestions utiles",
			suggestion1:
				"V\u00e9rifiez l\u2019URL dans la barre d\u2019adresse",
			suggestion2: "Retournez \u00e0 la page d\u2019accueil",
			suggestion3: "Utilisez la navigation principale",
			backHome: "Retour \u00e0 l\u2019accueil",
			backPrev: "Page pr\u00e9c\u00e9dente",
			helpText: "Besoin d\u2019aide\u00a0?",
			contactLink: "Contactez-nous",
		},
	},
	en: {
		nav: {
			allPasswords: "All passwords",
			secureNotes: "Secure notes",
			folders: "Folders",
			generator: "Generator",
			security: "Security",
			breachDetector: "Breach detector",
			contact: "Contact",
			home: "Home",
			settings: "Settings",
			stats: "Statistics",
			passwords: "Passwords",
			securityScore: "Security score",
			loading: "Loading...",
			secure: "Secured",
			encryptedWith: "Your data is encrypted with AES-256",
			signOut: "Sign out",
		},
		footer: {
			navigation: "Navigation",
			support: "Support",
			legal: "Legal",
			security: "Security",
			generator: "Generator",
			settings: "Settings",
			legalNotice: "Legal notice",
			privacy: "Privacy",
			terms: "Terms",
			cookies: "Cookies",
			encryption: "AES-256 Encryption",
			gdpr: "GDPR Compliant",
			copyright: "© {year} SkromaPASS. All rights reserved.",
			description:
				"Your secure password manager. Protect your online access with AES-256 encryption.",
			register: "Sign up",
			login: "Sign in",
			contact: "Contact",
			madeWith: "Made with ❤️ in France",
		},
		headerHome: {
			generator: "Generator",
			contact: "Contact",
			login: "Sign in",
			register: "Sign up",
			dashboard: "Dashboard",
			openMenu: "Open menu",
			closeMenu: "Close menu",
		},
		home: {
			badge: "Maximum security guaranteed",
			heroTitle1: "Your passwords,",
			heroTitle2: "totally secure",
			heroSubtitle:
				"Modern password manager with AES-256 encryption. Protect your online accounts with SkromaPASS.",
			ctaStart: "Start for free",
			ctaLogin: "Sign in",
			ctaDashboard: "Go to Dashboard",
			noCreditCard: "✓ No credit card required",
			featuresTitle: "Why choose SkromaPASS?",
			featuresSubtitle: "A complete solution to manage your passwords",
			feature1Title: "AES-256 Encryption",
			feature1Desc:
				"Your data is protected by secure encryption. Nobody can access your passwords, not even us.",
			feature2Title: "Secure generator",
			feature2Desc:
				"Create ultra-secure passwords in one click. Customize the length and character types for maximum security.",
			feature3Title: "Intuitive organization",
			feature3Desc:
				"Organize your passwords by folders and categories. Quickly find what you're looking for.",
			statsTitle: "Join SkromaPASS today!",
			statSecure: "Secure",
			statFree: "Free",
			statAvailable: "Available",
			ctaTitle: "Ready to secure your passwords?",
			ctaDesc: "Create your free account in less than a minute.",
			ctaButton: "Get started now",
			footerAboutDesc:
				"Your secure and intuitive password manager. Protect your data with AES-256 encryption.",
			footerNavTitle: "Navigation",
			footerLegalTitle: "Legal",
			legalNotice: "Legal notice",
			privacyPolicy: "Privacy policy",
			terms: "Terms",
			cookiePolicy: "Cookie policy",
			copyright: "All rights reserved.",
			footerInfo:
				"AES-256 Encryption | GDPR Compliant | Hosted in Europe",
			trust1: "AES-256",
			trust2: "GDPR Compliant",
			trust3: "Hosted in Europe",
			trust4: "100% Free",
			featuresLabel: "Features",
			feature4Title: "Multi-factor Auth",
			feature4Desc:
				"TOTP 2FA, PIN code and biometrics for maximum account protection.",
			feature5Title: "Breach Lab",
			feature5Desc:
				"Detect if your passwords have been compromised. Your data never leaves your device.",
			howTitle: "Ready in 3 steps",
			howStep1Num: "01",
			howStep1Title: "Create your account",
			howStep1Desc:
				"Free sign-up in 30 seconds. No credit card required.",
			howStep2Num: "02",
			howStep2Title: "Add your credentials",
			howStep2Desc:
				"Import from Chrome, Bitwarden, 1Password or add manually.",
			howStep3Num: "03",
			howStep3Title: "Install our browser extension (coming soon)",
			howStep3Desc:
				"Auto-fill and save your passwords directly in Chrome and Firefox.",
			extensionBadge: "Browser extension — Coming soon",
			extensionTitle: "Your vault inside your browser",
			extensionSubtitle:
				"Auto-fill, one-click save and built-in generator directly in Chrome and Firefox.",
			extensionChrome: "Google Chrome",
			extensionFirefox: "Mozilla Firefox",
			extensionFeature1: "Instant auto-fill",
			extensionFeature2: "One-click save",
			extensionFeature3: "Built-in password generator",
			extensionFeature4: "Direct vault access",
		},
		auth: {
			loginTitle: "Sign in",
			loginSubtitle: "Sign in to your account",
			email: "Email",
			password: "Password",
			forgotPassword: "Forgot password?",
			loginButton: "Sign in",
			loginLoading: "Signing in...",
			noAccount: "Don't have an account?",
			registerLink: "Sign up",
			errorCredentials: "Incorrect email or password",
			errorNotVerified:
				"Your email has not been verified yet. Please check your inbox.",
			errorGeneral: "An error occurred",
			errorNetwork: "An error occurred. Check your connection.",
			registerTitle: "Sign up",
			registerSubtitle: "Create your secure account",
			nameLabel: "Name",
			namePlaceholder: "Your name",
			passwordHint:
				"8 characters minimum, with uppercase, lowercase and number",
			confirmPassword: "Confirm password",
			registerButton: "Sign up",
			registerLoading: "Creating account...",
			successTitle: "Account created successfully!",
			successEmailPrefix: "A verification email has been sent to ",
			successEmailSuffix:
				". Please check your inbox and click the link to activate your account.",
			successButton: "Got it",
			spamNote: "Don't forget to check your spam folder!",
			alreadyAccount: "Already have an account?",
			loginLink: "Sign in",
			passwordMismatch: "Passwords do not match",
			forgotTitle: "Forgot password",
			forgotSubtitle: "Enter your email to receive a secure reset link.",
			emailLabel: "Email address",
			sendButton: "Send reset link",
			sendingButton: "Sending...",
			emailSentTitle: "Email sent!",
			emailSentPrefix: "If an account exists with the address ",
			emailSentMiddle: ", you will receive a reset link valid for ",
			emailSentDuration: "1 hour",
			spamCheck:
				"Also check your spam folder if you don't see the email.",
			backToLogin: "Back to sign in",
			resetTitle: "New password",
			resetSubtitle: "Choose a password for",
			newPasswordLabel: "New password",
			confirmPasswordLabel: "Confirm password",
			resetButton: "Reset password",
			resettingButton: "Resetting...",
			invalidLinkTitle: "Invalid link",
			invalidLinkDesc: "This reset link is invalid or has expired.",
			requestNewLink: "Request a new link",
			resetSuccessTitle: "Password changed!",
			resetSuccessDesc: "Your password has been reset successfully.",
			resetSuccessNote:
				"All your active sessions have been signed out. Please sign in with your new password.",
			signInButton: "Sign in",
			loadingPage: "Loading...",
			strengthMin8: "8 characters minimum",
			strengthLower: "Lowercase",
			strengthUpper: "Uppercase",
			strengthNumber: "Number",
			strengthSpecial: "Special character",
		},
		verifyEmail: {
			loadingTitle: "Verifying...",
			successTitle: "Email verified!",
			errorTitle: "Verification error",
			pendingTitle: "Check your email",
			loadingMsg: "Verifying...",
			successMsg: "Your email has been verified successfully!",
			errorInvalidToken:
				"The verification link is invalid or has expired. Please request a new verification email.",
			errorMissingParams: "Incomplete verification link.",
			errorServer: "An error occurred. Please try again later.",
			errorUnknown: "An unknown error occurred.",
			errorGeneral: "An error occurred during verification",
			pendingMsg: "Check your email inbox to confirm your address.",
			signIn: "Sign in",
			resendVerification: "Resend verification email",
			backRegister: "Back to registration",
			backLogin: "Back to sign in",
			spamTip: "💡 Tip: Also check your spam or junk folder.",
		},
		resendVerification: {
			title: "Resend verification email",
			subtitle:
				"Enter your email address to receive a new verification link",
			emailLabel: "Email",
			emailPlaceholder: "your@email.com",
			sendButton: "Resend email",
			sendingButton: "Sending...",
			errorGeneral: "An error occurred while sending",
			alreadyVerified: "Email already verified?",
			signIn: "Sign in",
			noAccount: "Don't have an account yet?",
			register: "Sign up",
			spamTip: "💡 Tip: Also check your spam or junk folder.",
		},
		onboarding: {
			welcomeTitle: "Welcome to SkromaPASS!",
			welcomeDesc:
				"Your account is created. Let's take 2 minutes to strengthen its security.",
			startButton: "Start setup",
			skipAll: "Skip and configure later in settings",
			doneTitle: "Setup complete!",
			doneDescNone:
				"You can configure these options at any time in your settings.",
			doneDescActivatedPrefix: "You have enabled",
			doneDescOptionSg: "security option",
			doneDescOptionPl: "security options",
			doneDescSuffix: "Your account is well protected.",
			ignored: "Skipped",
			goToDashboard: "Go to my dashboard",
			stepLabel: "Step",
			stepOf: "of",
			previousBtn: "Previous",
			twofaLabel: "Two-factor authentication",
			twofaDesc:
				"Protect your account with an app like Google Authenticator or Authy. A 6-digit code will be required at each login.",
			pinLabel: "PIN code",
			pinDesc:
				"Create a 4-to-8-digit PIN to access your passwords from your dashboard. This code is an extra security layer protecting your data even if your session is open.",
			bioLabel: "Biometrics",
			bioDesc:
				"Register your fingerprint or Face ID to access your passwords with a single touch.",
			tfaActivate: "Enable 2FA",
			tfaGenerating: "Generating QR code…",
			tfaScanDesc:
				"Scan this QR code with your app (Google Authenticator, Authy…)",
			tfaManualCode: "Manual code:",
			tfaInputPlaceholder: "6-digit code",
			tfaVerifying: "Verifying…",
			tfaConfirm: "Confirm",
			tfaEnabled: "2FA enabled!",
			tfaProtected: "Your account is now double-protected.",
			nextStep: "Next step",
			pinPasswordLabel: "Master password",
			pinPasswordPlaceholder: "Your password",
			pinNewLabel: "New PIN code (4–8 digits)",
			pinConfirmLabel: "Confirm PIN code",
			pinInvalid: "PIN must be between 4 and 8 digits",
			pinMismatch: "PIN codes do not match",
			pinCreating: "Setting up…",
			pinCreate: "Create my PIN",
			bioUnsupported:
				"Biometrics requires HTTPS and a compatible device. You can enable it later from settings.",
			bioContinue: "Continue without biometrics",
			bioDeviceLabel: "Device name",
			bioDevicePlaceholder: "My phone",
			bioRegistering: "Registering…",
			bioRegister: "Register my biometrics",
			skipStep: "Skip this step →",
		},
		tutorial: {
			nextBtn: "Next",
			finishBtn: "Finish",
			skipBtn: "Skip tutorial",
			step1Title: "Welcome to SkromaPASS!",
			step1Desc:
				"Discover your dashboard. Here you can see your security statistics: total number of passwords, strong passwords, and your overall security score.",
			step2Title: "Add a password",
			step2Desc:
				"Click here to add a new password. You can enter the site name, your credentials and even generate a secure password automatically.",
			step3Title: "Search quickly",
			step3Desc:
				"Use the search bar to instantly find your passwords by name, website or URL.",
			step4Title: "Sort and filter",
			step4Desc:
				"Use the sort options to order your passwords: most Recent, Alphabetical (A–Z), or by Strength. You can also filter directly by folder from the side menu.",
			step5Title: "Navigation menu",
			step5Desc:
				"Access all features through this side menu: password generator, folders, contact, settings...",
			step6Title: "Organize with folders",
			step6Desc:
				"Folders let you organize your passwords however you like. It is perfect for better organization!",
			step7Title: "Create a folder",
			step7Desc:
				"Click here to create a new folder. You can give it a name, a description and even choose a color to personalize it.",
			step8Title: "Access your folders",
			step8Desc:
				"Your folders appear here. Click on a folder to see all the passwords it contains. You can add passwords directly from the folder.",
			step9Title: "Enhanced security: Two-factor authentication",
			step9Desc:
				"Two-factor authentication (2FA) adds an extra layer of security. Even if someone knows your password, they won't be able to access your account without the 2FA code. I strongly recommend enabling it!",
			step10Title: "Quick access with PIN code",
			step10Desc:
				"Set up a PIN code (4 to 8 digits) to quickly access your passwords without having to type a long password every time. It is practical and secure!",
			step11Title: "Biometric access",
			step11Desc:
				"Register your fingerprint or Face ID to access your passwords with a single touch, instead of or in addition to your PIN code. Fast and secure!",
			step12Title: "Tutorial complete!",
			step12Desc:
				"You now know all the main features of SkromaPASS! Feel free to explore the app and secure all your passwords. 🔒",
		},
		dashboard: {
			loading: "Loading...",
			title: "My passwords",
			subtitle: "Manage all your passwords in one secure place",
			import: "Import",
			importTitle: "Import from Bitwarden, LastPass, Chrome...",
			export: "Export",
			exportTitle: "Export encrypted vault (.mkp)",
			addPassword: "Add a password",
			searchPlaceholder: "Search by name, email or URL...",
			stats: {
				total: "Total passwords",
				strong: "Strong passwords",
				score: "Security score",
			},
			filters: {
				all: "All",
				sort: {
					recent: "Recent",
					alpha: "A–Z",
					strength: "Strength",
				},
			},
			pagination: {
				of: "of",
			},
			empty: {
				title: "No passwords",
				allFolders: "Start by adding your first password",
				folder: "No passwords found in this folder",
			},
		},
		contact: {
			title: "Contact us",
			subtitle: "Have a question? A problem? We're here to help",
			supportTitle: "Email support",
			supportResponse: "Response within 24-48h on weekdays",
			tutorialTitle: "Interactive tutorial",
			tutorialDesc: "Rediscover the features",
			tutorialRestart: "Restart tutorial",
			nameLabel: "Full name",
			nameOptional: "(optional)",
			namePlaceholder: "Full name",
			emailLabel: "Email address",
			emailPlaceholder: "example@email.com",
			subjectLabel: "Subject",
			subjectPlaceholder: "What would you like to talk about?",
			messageLabel: "Message",
			messagePlaceholder: "Describe your request in detail...",
			sendButton: "Send message",
			sendingButton: "Sending...",
			successTitle: "Message sent successfully!",
			successDesc: "We will get back to you as soon as possible.",
			errorNetwork: "Unable to reach the server. Please try again.",
			privacyNote:
				"🔒 Privacy: Your information is secure and will never be shared with third parties.",
		},
		generator: {
			title: "Password Generator",
			subtitle: "Create secure and random passwords in seconds",
			generatedLabel: "Generated password",
			placeholder: "Click 'Generate' to create a password",
			ariaHide: "Hide password",
			ariaShow: "Show password",
			ariaCopy: "Copy password",
			copied: "✓ Copied to clipboard!",
			strengthWeak: "Weak",
			strengthMedium: "Medium",
			strengthStrong: "Strong",
			optionsTitle: "Generation options",
			lengthLabel: "Length:",
			lengthUnit: "characters",
			lowercase: "Lowercase letters (a-z)",
			uppercase: "Uppercase letters (A-Z)",
			numbers: "Numbers (0-9)",
			symbols: "Symbols (!@#$%^&*)",
			generateButton: "Generate a new password",
			tipsTitle: "💡 Security tips",
			tip1: "Use at least 12 characters for better security",
			tip2: "Include uppercase, lowercase, numbers and symbols",
			tip3: "Never reuse the same password on multiple sites",
			tip4: "Regularly change your important passwords",
			warningTitle: "Warning",
			warningMessage:
				"Please select at least one character type to generate a password.",
		},
		security: {
			title: "Security dashboard",
			subtitle:
				"Monitor your security and access advanced breach detection tools.",
			loading: "Loading...",
			scoreTitle: "Security score",
			scoreDesc: "Based on the strength and exposure of your passwords",
			scoreExcellent: "Excellent",
			scoreGood: "Good",
			scoreAvg: "Average",
			scoreWeak: "Weak",
			breachLabTitle: "Dedicated Breach Lab",
			breachLabDesc:
				"Full page to scan your vault, check a custom unregistered password and get instant advice.",
			breachLabNote:
				"Your passwords are never sent in plaintext thanks to the k-anonymity method.",
			openBreachLab: "Open Breach Lab",
			breachDetected: "Breaches detected",
			weakLabel: "Weak passwords",
			totalSecured: "Total secured",
			strongPasswords: "Strong passwords",
			mediumPasswords: "Medium passwords",
			weakPasswords: "Weak passwords",
			addedThisMonth: "Added this month",
			priorityTitle: "Priority recommendations",
			compromisedAlert: "account(s) detected in public breaches",
			compromisedAction:
				"Launch Breach Lab to get the list and fix them quickly.",
			weakAlert: "weak password(s)",
			weakAction: "Strengthen them with the built-in generator.",
			generateStrong: "Generate strong passwords",
			openGenerator: "Open generator",
			securityInfoTitle: "Security information",
			encryptionLabel: "Encryption",
			encryptionDesc: "Robust protection of sensitive data.",
			pinLabel: "Re-authentication PIN",
			pinTime: "15 minutes",
			pinDesc: "Additional verification to access your passwords.",
			tfaLabel: "Two-factor authentication",
			tfaOptional: "Optional",
			tfaDesc: "Enable 2FA for an extra security layer.",
			outerCardTitle: "Your security, our priority",
			outerCardDesc:
				"We are dedicated to protecting your data and providing you with the best tools to manage your security. Explore Breach Lab features, strengthen your passwords and stay informed to stay ahead of threats.",
		},
		vault: {
			title: "Secure notes",
			subtitle: "PIN codes, identities and notes encrypted securely",
			newNote: "New note",
			loading: "Loading...",
			emptyTitle: "No secure notes",
			emptyTitleAlt: "No notes",
			emptyDesc:
				"Store your PIN codes, identity information and sensitive notes in an encrypted format.",
			createFirst: "Create my first note",
			deleteTitle: "Delete note?",
			deleteConfirm: "Delete",
			deleteNotePrefix: "Delete ",
			deleteNoteSuffix: "? This action is irreversible.",
			modifiedPrefix: "Modified ",
			hide: "Hide",
			viewContent: "View content",
			copyContent: "Copy content",
			editAction: "Edit",
			deleteAction: "Delete",
		},
		folders: {
			title: "My folders",
			loading: "Loading...",
			folder: "folder",
			folders: "folders",
			newButton: "New folder",
			newButtonShort: "New",
			createTitle: "Create a new folder",
			nameLabel: "Folder name",
			namePlaceholder: "E.g. Work, Personal, Family...",
			descLabel: "Description",
			optional: "(optional)",
			descPlaceholder: "Describe the content of this folder...",
			colorLabel: "Folder color",
			creating: "Creating...",
			createButton: "Create folder",
			cancel: "Cancel",
			noDescription: "No description",
			password: "password",
			passwords: "passwords",
			emptyTitle: "No folders yet",
			emptyDesc: "Organize your passwords by creating themed folders.",
			emptyDescLine2: "Perfect for separating work and personal life!",
			createFirst: "Create my first folder",
			editTooltip: "Edit folder",
			deleteTooltip: "Delete folder",
			saving: "Saving...",
			saveChanges: "Save changes",
			errorCreate: "Error creating folder",
			errorDelete: "Error deleting",
			errorUpdate: "Error updating folder",
			deleteTitle: "Delete folder",
			deleteMessage:
				"Are you sure you want to delete this folder? All passwords it contains will also be deleted. This action is irreversible.",
			deleteConfirm: "Delete",
			errorAlertTitle: "Error",
		},
		folderDetail: {
			loading: "Loading folder...",
			notFound: "Folder not found",
			notFoundDesc: "This folder does not exist or has been deleted.",
			backToFolders: "Back to folders",
			breadcrumbFolders: "Folders",
			noDescription: "No description",
			password: "password",
			passwords: "passwords",
			addPassword: "Add a password",
			addPasswordShort: "Add",
			searchPlaceholder: "Search by name, email or URL...",
			noResults: "No results found",
			emptyFolder: "This folder is empty",
			noResultsDesc:
				"No password matches your search. Try different keywords.",
			emptyFolderDesc:
				"Start by adding your first password to this folder to better organize your credentials.",
			addFirst: "Add my first password",
			results: "result(s) found",
			passwordsCount: "password(s)",
			clearSearch: "Clear search",
		},
		settings: {
			title: "Settings",
			subtitle: "Manage your preferences and security settings",
			tabAccount: "Account",
			tabSecurity: "Security",
			accountTitle: "Account information",
			nameLabel: "Name",
			namePlaceholder: "Your name",
			emailLabel: "Email",
			saving: "Saving...",
			saveChanges: "Save changes",
			passwordTitle: "Change master password",
			currentPassword: "Current password",
			currentPasswordPlaceholder: "Your current password",
			newPassword: "New password",
			newPasswordPlaceholder: "At least 8 characters",
			confirmPassword: "Confirm password",
			confirmPasswordPlaceholder: "Confirm new password",
			changingPassword: "Updating...",
			changePassword: "Change password",
			generalTitle: "General information",
			accountCreated: "Account created on",
			emailVerifiedLabel: "Email verified",
			verified: "Verified",
			notVerified: "Not verified",
			savedPasswords: "Saved passwords",
			loading: "Loading...",
			deleteTitle: "Delete account",
			deleteDesc:
				"This action is irreversible. Your account and all your passwords will be permanently deleted. Make sure you have saved all important information before proceeding.",
			deletePlaceholder: "Enter your password to confirm",
			deleteButton: "Permanently delete my account",
			deleteModalTitle: "Delete your account",
			deleteModalMessage:
				"Are you sure you want to delete your account? All your passwords will be permanently deleted. This action is irreversible.",
			deleteModalConfirm: "Delete my account",
			errMustEnterPassword: "Please enter your password",
			errPasswordMismatch: "Passwords do not match",
			errPasswordTooShort: "Password must be at least 8 characters",
			successProfile: "Profile updated successfully",
			successPassword: "Password changed successfully",
			successDelete: "Account deleted. Redirecting...",
			errProfileUpdate: "Error updating profile",
			errPasswordChange: "Error changing password",
			errDeleteAccount: "Error deleting account",
		},
		pin: {
			title: "PIN Code",
			desc: "Set up a quick PIN code (4 to 8 digits) to access your passwords",
			configured: "PIN configured",
			notConfigured: "No PIN code",
			configuredDesc: "You can change or remove it",
			notConfiguredDesc: "Create a PIN for quick access",
			editBtn: "Edit",
			createBtn: "Create a PIN code",
			deleteBtn: "Remove",
			savingBtn: "Saving...",
			saveEditBtn: "Update PIN code",
			saveCreateBtn: "Create PIN code",
			cancelBtn: "Cancel",
			formTitle: "Create a PIN code",
			rule1: "Between 4 and 8 digits only",
			rule2: 'Don\'t use an obvious code like "1234" or "0000"',
			rule3: "Make sure to choose a PIN you can easily remember",
			rule4: "The PIN can be changed or removed at any time using your master password",
			passwordLabel: "Master password",
			passwordPlaceholder: "Enter your password",
			passwordHint: "To confirm your identity",
			newPinLabel: "New PIN code",
			pinPlaceholder: "4 to 8 digits",
			confirmPinLabel: "Confirm PIN code",
			confirmPinPlaceholder: "Repeat the PIN code",
			deleteModalTitle: "Delete PIN code",
			deleteModalDesc:
				"This action will permanently delete your PIN code. You will need to create a new one if you want to access your passwords in the future.",
			deleteModalPasswordLabel: "Master password",
			deleteModalPasswordPlaceholder: "Enter your password to confirm",
			deleteConfirmBtn: "Delete PIN",
			errLength: "PIN code must be between 4 and 8 digits",
			errDigitsOnly: "PIN code must contain digits only",
			errMismatch: "PIN codes do not match",
			errSetup: "Error during setup",
			errDelete: "Error during deletion",
			successModified: "PIN code updated successfully",
			successCreated: "PIN code created successfully",
			successDeleted: "PIN code deleted successfully",
		},
		twoFactor: {
			title: "Two-factor authentication",
			status: "Status:",
			enabled: "Enabled",
			disabled: "Disabled",
			desc: "Add an extra layer of security to your account by enabling two-factor authentication (2FA).",
			loadingBtn: "Loading...",
			enableBtn: "Enable 2FA",
			disableBtn: "Disable 2FA",
			scanStep: "Step 1: Scan the QR code",
			scanDesc:
				"Use Google Authenticator, Microsoft Authenticator, or any other compatible TOTP app.",
			manualScan: "Can't scan? Enter the key manually",
			secretLabel: "Secret key:",
			verifyStep: "Step 2: Verify the code",
			codeLabel: "Enter the 6-digit code",
			verifyingBtn: "Verifying...",
			activateBtn: "Activate",
			cancelBtn: "Cancel",
			disableCodeLabel: "Enter your 2FA code to disable",
			securityNote: "Enhanced security:",
			securityNoteText:
				"2FA adds an extra layer of protection by requiring a unique code at each login, even if someone knows your password.",
			errSetup: "Error during setup",
			errInvalidCode: "Invalid code",
		},
		biometric: {
			title: "Fingerprint / Face ID",
			desc: "Use your biometrics instead of your PIN to unlock your passwords.",
			checking: "Checking biometric support\u2026",
			httpsRequired: "HTTPS required",
			httpsDesc: "Biometric authentication is only available over HTTPS.",
			httpsLocal: "To test from a phone on local network:",
			notSupported:
				"Your browser does not support biometric authentication. Try an up-to-date Chrome or Safari.",
			registeredDevices: "Registered devices",
			addedOn: "Added on",
			deleteDeviceTooltip: "Remove this device",
			deleteDeviceConfirm:
				"Remove this device? You will no longer be able to use its biometrics to authenticate.",
			nameLabel: "Give this device a name (optional)",
			namePlaceholder: "E.g.: My iPhone, Desktop PC\u2026",
			registeringBtn: "Processing\u2026",
			registerBtn: "Confirm with your biometrics",
			cancelBtn: "Cancel",
			addDeviceBtn: "Register this device",
			defaultDeviceName: "My device",
			errInitRegister: "Unable to initialize registration.",
			errCancelled:
				"Registration cancelled. Please accept the biometric prompt.",
			errFailed: "Registration failed.",
			errDeleteFailed: "Deletion failed",
			successRegistered: "Biometrics registered successfully!",
			successDeleted: "Device removed.",
		},
		breachLab: {
			title: "Breach Detector",
			subtitle:
				"Check in one click if your passwords were stolen in a website breach. Your passwords never leave your device.",
			vaultCardTitle: "Scan all my passwords",
			vaultCardDesc:
				"Checks in seconds if any of your saved passwords has been compromised in a breach.",
			vaultCardNote:
				"🔒 Your passwords are never transmitted — only a partial hash is sent.",
			scanBtn: "Run scan",
			scanningBtn: "Scanning...",
			compromisedAlert:
				"⚠️ {n} password(s) found in known breaches — change them now.",
			safeAlert:
				"✅ None of your passwords were found in known breaches.",
			statsChecked: "Passwords checked",
			statsCompromised: "Compromised detected",
			statsUpdated: "Accounts updated",
			statsCompromisedList: "Compromised passwords:",
			breachCount: "{n} breach(es)",
			manualCardTitle: "Test a password",
			manualCardDesc:
				"You can test any password here — even one you haven't saved yet.",
			manualCardNote:
				"🔒 This password is never stored or transmitted in plaintext.",
			manualPlaceholder: "Type a password to test...",
			strengthLabel: "Security level",
			crackTimeText: "A hacker would need {time} to guess this password.",
			checkBtn: "Check if this password has been leaked",
			checkingBtn: "Checking...",
			compromisedManualAlert:
				"⚠️ This password was found in known breaches — avoid using it.",
			safeManualAlert:
				"✅ This password was not found in known breaches.",
			seenTimes: "Seen {n} times in website breaches",
			howTitle: "How does it work?",
			howPrivacyTitle: "🔒 Your privacy is protected",
			howPrivacyDesc:
				"Your password is never sent over the internet. Only a truncated, unreadable version is used for verification.",
			howSpeedTitle: "⚡ Instant results",
			howSpeedDesc:
				"The analysis relies on a database of billions of passwords stolen in real website breaches.",
			howActionTitle: "🎯 What to do if a password has leaked?",
			howActionDesc:
				"Change it immediately on the relevant site and generate a new, unique, strong password.",
			generateBtn: "Generate a strong password",
			scanUnavailable: "Scan unavailable",
			enterPassword: "Enter a password to check.",
			checkUnavailable: "Check unavailable",
			strength1: "Very weak — change immediately",
			strength2: "Weak — easy to guess",
			strength3: "Medium — could be improved",
			strength4: "Strong — good password",
			strength5: "Very strong — excellent choice!",
			crack0: "a few seconds",
			crack1: "a few minutes",
			crack2: "several days",
			crack3: "several years",
			crack4: "centuries",
			riskCritical: "🔴 Critical risk",
			riskHigh: "🟠 High risk",
			riskMedium: "🟡 Moderate risk",
			riskLow: "🟢 Low risk",
			riskNone: "✅ No breach detected",
		},
		passwordModal: {
			title: "Add a password",
			editTitle: "Edit password",
			nameLabel: "Site / service name",
			editNameLabel: "Site / app name",
			namePlaceholder: "Google, Facebook, etc.",
			editNamePlaceholder: "E.g.: Facebook, Gmail...",
			optional: "(optional)",
			usernameLabel: "Username",
			usernamePlaceholder: "user@example.com",
			editUsernamePlaceholder: "username123",
			emailLabel: "Email",
			emailPlaceholder: "user@example.com",
			editEmailPlaceholder: "email@example.com",
			passwordLabel: "Password",
			passwordPlaceholder: "Secure password",
			generate: "Generate",
			generateSecure: "Generate a secure password",
			strengthLabel: "Password strength",
			strengthWeak: "Weak",
			strengthMedium: "Medium",
			strengthStrong: "Strong",
			websiteLabel: "Website",
			websitePlaceholder: "example.com",
			folderLabel: "Folder",
			folderNew: "New",
			folderNone: "No folder",
			folderNamePlaceholder: "Folder name",
			folderCreate: "Create",
			notesLabel: "Notes",
			notesPlaceholder: "Additional notes...",
			cancel: "Cancel",
			submit: "Add",
			submitting: "Adding...",
			editSubmit: "Save",
			editSubmitting: "Saving...",
			errorTitle: "Error",
			errorMessage:
				"An error occurred while saving the password. Please try again.",
			addError: "Error adding the password. Please try again.",
			editError: "Error editing the password. Please try again.",
		},
		passwordCard: {
			copied: "Copied!",
			modifiedPrefix: "Modified ",
			shareTitle: "Share this password",
			viewTitle: "Show password",
			hideTitle: "Hide password",
			editTitle: "Edit password",
			copiedTitle: "Copy to clipboard",
			deleteTitle: "Delete password",
			deleteMessagePrefix: "Are you sure you want to delete \u201c",
			deleteMessageSuffix: "\u201d? This action is irreversible.",
			deleteConfirmBtn: "Delete",
			errorTitle: "Error",
			errorMessage: "Error deleting the password. Please try again.",
			notesLabel: "Notes",
			timeAgoNow: "Just now",
			timeAgoPrefix: "",
			timeAgoSuffix: "ago",
			timeUnitYear: "year",
			timeUnitYearPlural: "years",
			timeUnitMonth: "month",
			timeUnitMonthPlural: "months",
			timeUnitWeek: "week",
			timeUnitWeekPlural: "weeks",
			timeUnitDay: "day",
			timeUnitDayPlural: "days",
			timeUnitHour: "hour",
			timeUnitHourPlural: "hours",
			timeUnitMinute: "minute",
			timeUnitMinutePlural: "minutes",
		},
		exportModal: {
			title: "Export vault",
			subtitle: "Encrypted .mkp format",
			warningTitle: "Export password — don't forget it!",
			warningDesc:
				"This password encrypts your entire vault. Without it, you won't be able to reimport your data. Note it in a safe place before downloading the file.",
			passwordLabel: "Export password",
			passwordPlaceholder: "Minimum 8 characters",
			confirmLabel: "Confirm password",
			confirmPlaceholder: "Repeat the password",
			cancel: "Cancel",
			submit: "Download",
			submitting: "Exporting...",
			successTitle: "Export successful!",
			successDesc:
				"Your vault has been downloaded. Keep the .mkp file and your export password safe — without this password, the data cannot be recovered.",
			close: "Close",
			errTooShort: "Password must be at least 8 characters.",
			errMismatch: "Passwords do not match.",
			errExport: "Error during export",
			exporting: "Exporting...",
			download: "Download",
		},
		importModal: {
			title: "Import passwords",
			subtitle: "From another manager or a SkromaPASS export",
			tabCsv: "CSV file",
			tabMkp: "SkromaPASS export (.mkp)",
			csvGuideTitle: "How to export from your manager:",
			dropCsv: "Click or drag and drop a CSV file",
			dropMkp: "Click or drag and drop a .mkp file",
			dropping: "Drop the file here",
			maxSizeCsv: "Maximum size: 5 MB",
			mkpDesc:
				"Select a .mkp file exported from SkromaPASS, then enter the export password you defined during export.",
			fileLoaded: "File loaded",
			mkpFileLoaded: ".mkp file loaded",
			detected: "{n} password(s) detected",
			warningDups:
				"Passwords will be added to your existing vault. Duplicates are not removed automatically.",
			changeFile: "Change file",
			importBtn: "Import {n} password(s)",
			importing: "Importing...",
			exportPasswordLabel: "Export password",
			exportPasswordPlaceholder: "The password set during export",
			decrypting: "Decrypting...",
			importMkpBtn: "Import",
			successTitle: "Import successful!",
			successDesc: "{n} password(s) successfully imported",
			close: "Close",
			errCsvType: "Please select a CSV file",
			errCsvSize: "File too large (5 MB maximum)",
			errMkpType: "Please select a .mkp file",
			errMkpSize: "File too large (10 MB maximum)",
			errImport: "Error during import",
			otherTools: "Manager with CSV export compatible",
			BitwardenGuide: " Tools → Export vault (CSV)",
			LastPassGuide: " Settings → Export",
			"1PasswordGuide": " File → Export (CSV)",
			ChromeGuide: " chrome://settings/passwords → Export",
		},
		reauthModal: {
			title: "Security check",
			subtitle: "To display your passwords",
			noPinTitle: "PIN code not configured",
			noPinDesc:
				"Please configure a PIN in settings to continue. This is an additional security layer to protect your data.",
			bioWaiting: "Waiting for your biometrics…",
			bioTitle: "Biometric verification",
			bioSubtitle: "Use your fingerprint or Face ID",
			bioRetry: "Retry",
			bioWaitingBtn: "Waiting…",
			usePinInstead: "Use PIN code instead",
			useBiometric: "Use biometrics",
			pinLabel: "Enter your PIN code",
			backspace: "← Delete",
			securityInfo:
				"🔒 Security: This check is valid for 15 minutes. You won't need to re-authenticate during that time.",
			errBioInit: "Unable to initialize biometric verification.",
			errBioCancelled: "Biometric authentication cancelled.",
			errBioDevice: "Your device could not verify your identity.",
			errBioFailed: "Biometric verification failed.",
			errPinIncorrect: "Incorrect PIN code",
		},
		secureNoteModal: {
			addTitle: "New secure note",
			editTitle: "Edit note",
			titleLabel: "Title",
			titlePlaceholder: "E.g.: Visa card, Wifi code...",
			contentLabel: "Content",
			contentPlaceholder: "Write your note, PIN code, card number...",
			encryptedNote:
				"Content is encrypted with AES-256-GCM before being stored",
			cancel: "Cancel",
			save: "Save",
			saving: "Saving...",
			create: "Create note",
			errTitle: "Title is required",
			errContent: "Content is required",
			errSave: "Error saving the note",
		},
		shareModal: {
			title: "Share this password",
			securityNote:
				"Encrypted in your browser — the server never sees the password in cleartext. The decryption key is embedded in the link.",
			linkTitleLabel: "Link title",
			showNameToggle: "Show a title to the recipient",
			hiddenNameHint:
				'The recipient will see "Shared password" as the title.',
			defaultName: "Shared password",
			expiryLabel: "Link expiry",
			expiry1h: "1 hour",
			expiry24h: "24 hours",
			expiry3d: "3 days",
			expiry7d: "7 days",
			maxViewsLabel: "Maximum number of uses",
			viewsCount: "{n} times",
			cancel: "Cancel",
			createBtn: "Create link",
			creating: "Creating...",
			successMsg: "Link created successfully! Valid {time} • {n} use(s)",
			shareLink: "Share link",
			copy: "Copy",
			copied: "Copied!",
			warningShare: "Share this link only with the intended recipient.",
			warningKey:
				"The #key part after the link is essential for decryption — copy the full link.",
			close: "Close",
			err: "Error creating the link",
			linkCreated: "Link successfully created! Valid",
			use: "use",
			fieldsLabel: "Fields to share",
			fieldPassword: "Password",
			fieldAlwaysRequired: "(always included)",
			fieldUsername: "Username",
			fieldEmail: "Email",
			fieldWebsite: "Website",
			fieldNotes: "Notes",
		},
		authRequired: {
			login: "Login",
			register: "Sign up",
			title: "Login required",
			desc: "You must be logged in to access this page. Sign in or create an account to continue.",
			loginBtn: "Sign in",
			registerBtn: "Create account",
			backHome: "\u2190 Back to home",
		},
		shareToken: {
			copy: "Copy",
			copied: "Copied!",
			hide: "Hide",
			show: "Show",
			loading: "Verifying link...",
			sharedPassword: "Shared password",
			warningTitle: "Before revealing this password:",
			warningDevice: "Make sure you are on a secure device",
			warningCount: "This action will count as one use of the link",
			warningLast: "This is the last available use",
			viewsRemainingOne: "use remaining",
			viewsRemainingPlural: "uses remaining",
			expireOn: "Expires on",
			decrypting: "Decrypting...",
			revealBtn: "Reveal password",
			fieldUsername: "Username / Email",
			fieldPassword: "Password",
			fieldWebsite: "Website",
			fieldNotes: "Notes",
			viewLeft: "view remaining",
			viewsLeft: "views remaining",
			expiredTitle: "This link has expired",
			exhaustedTitle: "Link exhausted",
			expiredDesc: "This share link is no longer valid.",
			exhaustedDesc:
				"This link has already been used the maximum number of times.",
			errorTitle: "Link not found",
			footerSharedVia: "Shared via",
			footerTagline: "Encrypted password manager",
			errMissingToken: "Missing token",
			errUnknown: "Unknown error",
			errServerUnreachable: "Unable to reach server",
			errMissingKey:
				"Missing or invalid decryption key \u2014 copy the entire link (including the part after #)",
			errDecrypt:
				"Unable to decrypt \u2014 invalid key or corrupted link",
		},
		notFound: {
			title: "Page not found",
			subtitle:
				"Oops! The page you're looking for doesn't seem to exist. It may have been moved or no longer exists.",
			suggestions: "Helpful suggestions",
			suggestion1: "Check the URL in the address bar",
			suggestion2: "Go back to the homepage",
			suggestion3: "Use the main navigation",
			backHome: "Back to homepage",
			backPrev: "Previous page",
			helpText: "Need help?",
			contactLink: "Contact us",
		},
	},
};
